/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Col_ValvesInputs */

const vi_irrigation_devices_col_valves = /** @type {(inputs: Irrigation_Devices_Col_ValvesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van`)
};

/**

* @param {Irrigation_Devices_Col_ValvesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_col_valves = /** @type {((inputs?: Irrigation_Devices_Col_ValvesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Col_ValvesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_col_valves(inputs)
});